// SceneForm.form.js
import * as Yup from "yup";

export const departamentOptions = [
  { key: "e360", text: "Educa360", value: "Educa360" },
  { key: "edv", text: "Educaverse", value: "Educaverse" },
  { key: "job", text: "EducaJob", value: "EducaJob" },
  { key: "eds", text: "EducaSenior", value: "EducaSenior" },
  // Agrega más departamentos según sea necesario
];

export const accountOptions = [
  { key: "free", text: "Free", value: "free" },
  { key: "premium", text: "Premium", value: "premium" },
  { key: "promo", text: "Promoción", value: "promocion" },
];

// Valores iniciales
export function initialValuesZero(scene) {
  return {
    departament: scene?.departament || "Educa360",
    idScene: scene?.idScene || "",
    account: scene?.account || "free",
  };
}

// Esquema de validación
export function validationSchemaZero() {
  return Yup.object({
    departament: Yup.string().required("El departamento es obligatorio"),
    idScene: Yup.string().required("El ID de la escena es obligatorio"),
    account: Yup.string().required("Selecciona el tipo de cuenta"),
  });
}
